import { render, staticRenderFns } from "./SectionButtons.vue?vue&type=template&id=11dbb777&scoped=true&"
import script from "./SectionButtons.vue?vue&type=script&lang=ts&"
export * from "./SectionButtons.vue?vue&type=script&lang=ts&"
import style0 from "./SectionButtons.vue?vue&type=style&index=0&id=11dbb777&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11dbb777",
  null
  
)

export default component.exports